export default {
    App: {
        'Browse stock equipment': 'Explorar equipo en stock',
        'Contact Kalmar': 'Póngase en contacto con Kalmar',
        'Create new': 'Crear nuevo',
        'Dealer community': 'Dealer community',
        'Download failed': 'Error de descarga',
        'Failed to get service reports': 'Error al obtener informes de servicio',
        'Kalmar Care service request': 'Solicitud de servicio Kalmar Care',
        'Kalmar Training Academy': 'Academia de formación Kalmar',
        'Kalmar Used Equipment': 'Equipos Usados Kalmar',
        'Loading MyKalmar': 'Cargando MyKalmar',
        'Login again': 'Volver a iniciar sesión',
        'Maintenance reporting': 'Informes de mantenimiento',
        'Maintenance schedule': 'Programa de mantenimiento',
        'Manuals': 'Manuales',
        'My Cases': 'Mis Casos',
        'MyKalmar homepage': 'Página de inicio de MyKalmar',
        'MyParts': 'MyParts',
        'Navigating to MyParts failed': 'Error al navegar hasta MyParts',
        'No service reports found': 'No se han encontrado informes de servicio',
        'None': 'Ninguno',
        'Open Dealer community': 'Comunidad de distribuidores abierta',
        'Open MyKalmar INSIGHT': 'Abierta MyKalmar INSIGHT',
        'Open MyKalmar STORE': 'Abrir MyKalmar STORE',
        'Open used equipment sales portal': 'Abrir portal de venta de equipos usados',
        'Parts order history': 'Historial de pedidos',
        'Read more and subscribe': 'Más información y suscripción',
        'Read more and register': 'Más información e inscripción',
        'Register Kalmar equipment': 'Registrar maquinaria Kalmar',
        'Request training': 'Solicitar formación',
        'Request service': 'Solicitar servicio',
        'Show manuals search': 'Mostrar búsqueda de manuales',
        'Show all ({{ equipmentLength }}) equipment': 'Mostrar todos los equipos ({{ equipmentLength }})',
        'Show all Kalmar contacts': 'Mostrar todos los contactos de Kalmar',
        'Show all cases': 'Mostrar todos los casos',
        'Show on calendar': 'Mostrar en el calendario',
        'Show requests': 'Mostrar solicitudes',
        'Try again': 'Volver a intentarlo',
        'You are now logged out from MyKalmar': 'Ya ha cerrado la sesión de MyKalmar',
        'Open TechSight': 'Abrir TechSight',
        'Solve smarter: your one-stop information source': 'Resuelva de forma más inteligente: su fuente de información única',
    },
    BackToTop: {
        'Back to top': 'Volver arriba',
    },
    Banner: {
        'Boost driving skills and technical expertise with Kalmar Training Academy specialized training courses, designed to keep your team & equipment safe and reliable.': 'Mejore las habilidades de conducción y la experiencia técnica con los cursos de formación especializados de la Kalmar Training Academy, diseñados para mantener a su equipo y equipo seguros y fiables.',
        'Check details for your equipment until they last.': 'Consulte los detalles de su equipo hasta que se agoten.',
        'Discover how to get the most out of your equipment.': 'Descubre cómo sacarle el máximo partido a tu equipo.',
        'Ensure uptime, optimize your operations, and much more.': 'Garantice el tiempo de actividad, optimice sus operaciones y mucho más.',
        'Explore Kalmar Services': 'Explora los servicios de Kalmar',
        'FLASH Sale is now on - Save up to 70%': '¡La venta FLASH ya está en marcha: ahorre hasta un 70%!',
        'Go to STORE': 'Ir a STORE',
        'Learn more': 'Aprende más',
        'Register in STORE now': 'Regístrese en STORE ahora',
        'Selected Kalmar Genuine Parts now discounted in the MyKalmar STORE Outlet.': 'Piezas genuinas Kalmar seleccionadas ahora con descuento en el MyKalmar STORE Outlet.',
        'Take your team’s performance to the next level!': 'Lleve el rendimiento de su equipo al siguiente nivel!',
    },
    BulletinsTab: {
        'Bulletin': 'Boletín',
        'Bulletins': 'Boletines',
        'Product': 'Producto',
        'Subject': 'Asunto',
        'Date': 'Fecha',
        'Open pdf': 'Abrir PDF',
        'Search bulletins': 'Buscar boletines',
        'Select equipment': 'Seleccionar equipo',
        'Category': 'Categoría',
        'Select category': 'Seleccionar categoría',
        'No bulletins for your fleet.': 'No hay boletines para su flota.',
        'Bulletins are currently available for select equipment types only. We are actively expanding coverage to include the rest of your fleet in upcoming updates.': 'Actualmente, los boletines solo están disponibles para determinados tipos de equipos. Estamos ampliando activamente la cobertura para incluir al resto de su flota en próximas actualizaciones.',
        'Bulletins are visible to Kalmar internal users only.': 'Los boletines solo son visibles para los usuarios internos de Kalmar.',
    },
    Common: {
        'All': 'Todos',
        'Language': 'Idioma',
        'Select language': 'Seleccionar idioma',
        'Availability': 'Disponibilidad',
        'Call the number': 'Llamar al número',
        'called': 'Llamado',
        'Cancel': 'Cancelar',
        'Close': 'Cerrar',
        'completed': 'Completado',
        'Contracts': 'Contratos',
        'Customer number': 'Número de cliente',
        'declined': 'Rechazado',
        'Description': 'Descripción',
        'Details': 'Detalles',
        'Maintenance': 'Mantenimiento',
        'Monthly': 'Mensual',
        'Monthly report': 'Informe mensual',
        'My Equipment': 'Mi Equipo',
        'N/A': 'No aplicable',
        'Name': 'Nombre',
        'No data': 'Sin datos',
        'No data for this time period': 'Sin datos para este periodo de tiempo',
        'OK': 'OK',
        'ordered': 'Pedido',
        'Other': 'Otro',
        'Other Equipment': 'Otro equipo',
        'Stock equipment': 'Equipo en stock',
        'Register Kalmar equipment': 'Registrar maquinaria Kalmar',
        'Request submission failed': 'Error al enviar la solicitud',
        'Response Time': 'Tiempo de respuesta',
        'scheduled': 'Programado',
        'See details': 'Consultar detalles',
        'Send': 'Enviar',
        'Serial number': 'Número de serie',
        'Show on page': 'Mostrar en la página',
        'Site': 'Lugar',
        'Something went wrong': 'Ha ocurrido un problema',
        'Status': 'Estado',
        'today': 'hoy',
        'Type': 'Tipo',
        'Unknown': 'Desconocido',
        'User': 'Usuario',
        'Yearly': 'Anualmente',
        'Yearly trend': 'Tendencia anual',
        'Search': 'Buscar',
        'Open': 'Abrir',
        'Welcome to MyKalmar': 'Bienvenido a MyKalmar',

    },
    ContactWidget: {
        'Contact us!': '¡Contáctenos!',
        'Email': 'Correo electrónico',
        'Need help?  Or need to know more about our services?': '¿Necesita ayuda? ¿Necesita saber más sobre nuestros servicios?',
        'Phone': 'Teléfono',
        'Send email': 'Enviar correo electrónico',
    },
    CustomerSelector: {
        'No results found with': 'No se encontraron resultados con',
        'Search with name, city, street address or sold-to number': 'Search with name, city, street address or sold-to number',
        'Select customer': 'Seleccionar cliente',
    },
    DataRequestForm: {
        'Acceptance of Data Notice': 'Aceptación del Aviso de Datos',
        'Company name': 'Nombre de la empresa',
        'Contact us': 'Contáctenos',
        'Data Act Notice': 'Aviso de la Ley de Datos',
        'Data request sent': 'Solicitud de datos enviada',
        'Date of data concerned by the request': 'Fecha de los datos a los que se refiere la solicitud',
        'Details': 'Detalles',
        'Error sending data request:': 'Error al enviar la solicitud de datos:',
        'Fill request form': 'Rellenar formulario de solicitud',
        'Form for data access request': 'Formulario para solicitud de acceso a datos',
        'I have read and agree to the': 'He leído y acepto el',
        'Name': 'Nombre',
        'No customer selected': 'Ningún cliente seleccionado',
        'Open comments': 'Comentarios abiertos',
        'Or alternatively,': 'O alternativamente,',
        'Position/relationship with the Company': 'Cargo/relación con la empresa',
        'Products concerned by the request (e.g. serial number)': 'Productos a los que se refiere la solicitud (por ejemplo, número de serie)',
        'Something went wrong': 'Ha ocurrido un problema',
        'Thank you for your data request': 'Gracias por su solicitud de datos',
        'Past data': 'Datos pasados',
        'Present data': 'Datos actuales',
        'Required data': 'Datos requeridos',
        'Alternatively, please contact us at': 'Alternativamente, contáctenos en',
    },
    DealerCommunity: {
        'Sales & general information': 'Ventas e información general',
        'Marketing & products': 'Marketing y productos',
        'Technical library': 'Biblioteca técnica',
        'News': 'Noticias',
        'Kalmar contacts': 'Contactos de Kalmar',
    },
    DocumentationTab: {
        'Manuals': 'Manuales',
        'Manual': 'Manual',
        'Open': 'Abrir',
        'Select language': 'Seleccione el idioma',
        'See more manuals in other languages': 'Ver más manuales en otros idiomas',
        'Search manuals with serial number': 'Buscar manuales con número de serie',
    },
    EmptyWidgets: {
        'Buy genuine parts': 'Comprar piezas genuinas',
        'By registering your equipment you can see manuals, contracts and more.': 'Al registrar su equipo podrá ver manuales, contratos y mucho más.',
        'Create a case': 'Crear un caso',
        'Do you have an inquiry?': '¿Tiene alguna consulta?',
        'Description (serial numbers of all the equipment you want to register)': 'Descripción (números de serie de toda la maquinaria que desea registrar)',
        'Kalmar Services': 'Kalmar Services',
        'Performance management tool for cargo handling operations': 'Herramienta de gestión del rendimiento para operaciones de manipulación de carga',
        'Phone number': 'Número de teléfono',
        'Registration request received': 'Solicitud de registro recibida',
        'Thank you for your registration request. We will handle your request as soon as possible.': 'Gracias por su solicitud de registro. Tramitaremos su solicitud lo antes posible.',

    },
    EquipmentAvailability: {
        'Equipment Type': 'Tipos de equipos',
        'Month': 'Mes',
        'Quarter': 'Trimestre',
        'Year': 'Año',
    },
    EquipmentAvailabilityByType: {
        'Time spent': 'Tiempo dedicado',
    },
    Footer: {
        'General conditions': 'Condiciones generales',
        'Kalmar in Social Media': 'Kalmar en las redes sociales',
        'Kalmar Digital Service Terms & Conditions': 'Términos y condiciones del servicio digital de Kalmar',
        'Privacy policy': 'Política de privacidad',
        'EU Data Act': 'Ley de datos de la UE',
        'For data questions, please contact': 'Para preguntas sobre datos, comuníquese con',
    },
    KalmarInsightWidget: {
        'equipment': 'equipo',
        'Expired license': 'Licencia caducada',
        'License expiring soon': 'Licencia caduca pronto',
        'Manage users': 'Administrar usuarios',
        'Number of MyKalmar INSIGHT users': 'Número de Usuarios de MyKalmar INSIGHT',
        'Valid license': 'Licencia válida',
    },
    LanguageSelector: {
        'Select language': 'Seleccione el idioma',
    },
    LoadingFailure: {
        'Loading cases failed': 'Error al cargar casos',
        'Loading equipment availability failed': 'Error al cargar disponibilidad de equipo',
        'Loading equipment failed': 'Error al cargar equipo',
        'Loading failed': 'Error al cargar',
        'Loading maintenance schedule failed': 'Error al cargar programa de mantenimiento',
        'Loading preventive maintenance data failed': 'Error al cargar datos de mantenimiento preventivo',
        'Loading response time failed': 'Error al cargar tiempo de respuesta',
        'Loading sales orders failed': 'Error al cargar órdenes de venta',
        'Retry': 'Reintentar',
    },
    MaintenanceCalendar: {
        'Equipment name': 'Nombre del equipo',
        'Maintenance description': 'Descripción del mantenimiento',
        'No maintenance scheduled for the selected day.': 'No hay mantenimiento programado para el día seleccionado.',
    },
    MaintenanceReporting: {
        'Equipment availability': 'Disponibilidad del equipo',
        'Preventive maintenance': 'Mantenimiento preventivo',

    },
    MaintenanceReportingWidget: {
        'Average duration from breakdown to the first service operation start': 'Average duration from breakdown to the first service operation start',
        'Average percentage the equipment was available': 'Porcentaje medio que el equipo estaba disponible',
        'Planned maintenance operations that were completed on time': 'Planned maintenance operations that were completed on time',
    },
    MaintenanceScheduleWidget: {
        'No upcoming maintenances': 'Ningún mantenimiento próximo',
        'Upcoming maintenances': 'Mantenimientos próximos',
    },
    MasterHeader: {
        'Go to MyKalmar STORE or MyKalmar INSIGHT': 'Vaya a MyKalmar STORE o MyKalmar INSIGHT',
        'Language': 'Idioma',
        'Log out': 'Cerrar sesión',
        'MyKalmar profile': 'MyKalmar perfil',
        'You can go to MyKalmar STORE and MyKalmar INSIGHT by clicking here': 'Puede ir a MyKalmar STORE y MyKalmar INSIGHT haciendo clic aquí',
    },
    MyCasesWidget: {
        'An unknown value': 'Un valor desconocido',
        'Automation': 'Automatización',
        'Case': 'Caso',
        'changed from': 'cambiado de',
        'Comment': 'Comentario',
        'n/a': 'n/a',
        'New comment': 'Nuevo comentario',
        'No recent updates to cases': 'No hay actualizaciones recientes de los casos',
        'Priority': 'Prioridad',
        'Recent updates': 'Actualizaciones recientes',
        'Resolution_Date__c': 'Resolution date',
        'STORE': 'STORE',
        'to': 'a',
        'updated': 'actualizado',
        'Updated at': 'Actualizado en',
    },
    MyEquipment: {
        'Bulletins': 'Boletines',
        'Contracts': 'Contratos',
        'Digital subscriptions': 'Suscripciones digitales',
        'Documentation': 'Documentación',
        'Equipment details': 'Detalles del equipo',
        'Equipment name': 'Nombre del equipo',
        'MyKalmar INSIGHT': 'MyKalmar INSIGHT',
        'Leasing': 'Arrendamiento',
        'Model': 'Modelo',
        'Search equipment with name, site, serial number or type': 'Buscar equipos con nombre, lugar, número de serie o tipo',
        'Search with name, serial number or type': 'Buscar con nombre, número de serie o tipo',
        'Serial number': 'Número de serie',
        'Short-term rental': 'Alquiler a corto plazo',
    },
    MyEquipmentItem: {
        'Contract ends': 'El contrato finaliza',
        'Contract started': 'El contrato comenzó',
        'No contracts': 'Sin contratos',
        'Contact Kalmar for signing a contract': 'Contacte con Kalmar para firmar un contrato',
        'Equipment details': 'Detalles del equipo',
        'insight': 'MyKalmar INSIGHT',
        'leasing': 'Arrendamiento',
        'Machine card': 'Tarjeta de máquina',
        'maintenance': 'Mantenimiento',
        'Maintenance schedule': 'Programa de mantenimiento',
        'Manufacturing year': 'Año de fabricación',
        'Model': 'Modelo',
        'No data': 'Sin datos',
        'No equipment found': 'No se ha encontrado ningún equipo',
        'Open': 'Ouvrir',
        'Order parts': 'Pedir piezas',
        'Owner': 'Propietario',
        'rental-short-term': 'Alquiler a corto plazo',
        'Running hours': 'Horas de trabajo',
        'See Insights': 'Ver Información',
        'Serial number': 'Número de serie',
        'Today': 'Hoy',
        'Preventive maintenance reports': 'Informes de mantenimiento preventivo',
        'No preventive maintenance reports': 'No hay informes de mantenimiento preventivo',
        'Preventive maintenance reports are generated after certified Kalmar service inspections. Book a service inspection with our local team to keep your equipment running reliably.':
            'Los informes de mantenimiento preventivo se elaboran tras las revisiones de servicio certificadas de Kalmar. Reserva una revisión de servicio con nuestro equipo local para garantizar el funcionamiento fiable de su equipo.',
        'Learn more about Kalmar maintenance': 'Obtenga más información sobre el mantenimiento de Kalmar',
        'Learn more about Kalmar Care': 'Obtenga más información sobre Kalmar Care',
        'Maintenance records are temporarily unavailable': 'Los registros de mantenimiento no están disponibles temporalmente',
        'Service order': 'Orden de servicio',
        'Maintenance interval': 'Intervalo de mantenimiento',
        'Date': 'Fecha',
        'Faults': 'Fallos',
        'Comments': 'Comentarios',
        'View comments': 'Ver comentarios',
        'Open pdf': 'Abrir PDF',
        'Chapter': 'Capítulo',
        'Checkpoint': 'Punto de control',
        'Comment': 'Comentario',
    },
    MyEquipmentWidget: {},
    MyPartsWidget: {
        'Customer PO': 'PO del cliente',
        'Delivered': 'Entregado',
        'My last parts orders': 'Mis últimos pedidos de piezas',
        'No orders': 'Sin pedidos',
        'Note: this order will be delivered in multiple shipments.': 'Nota: Este pedido se entregará en varios envíos.',
        'Order at warehouse': 'En el almacén',
        'Order number': 'Número de orden',
        'Order received': 'Pedido recibido',
        'Processing': 'En proceso',
        'Shipment': 'Envío',
        'Shipped': 'Enviado',
        'Tracking': 'Seguimiento',
        'Tracking information not available at the moment': 'Información de seguimiento no disponible en este momento',
        'Not available': 'No disponible',
        'Hide tracking': 'Ocultar seguimiento',
        'View tracking': 'Ver seguimiento',
        'Please wait for tracking information...': 'Por favor, espere la información de seguimiento...',
        'Est. Delivery': 'Entrega estimada',
    },
    NotFound: {
        'Go to home page': 'Ir a la página de inicio',
        'Page not found': 'Página no encontrada',
        'The page may have been moved or you may not have the necessary rights to access this page': 'Es posible que la página haya sido movida o que no tenga los derechos necesarios para acceder a ella',
    },
    PaginationTable: {
        "itemsCurrentlyShownText": "{{shownItemAmount}} de {{maxItemAmount}} mostrados"
    },
    PreventiveMaintenanceCompletion: {
        'Completed': 'Completado',
        'completed in': 'completado en',
        'Count': 'Recuento',
        'No data for': 'Sin datos para',
        'Not completed': 'No completado',
        'Percentage': 'Porcentaje',
        'Planned': 'Planeado',
        'tasks': 'tareas',
    },
    ResponseTime: {
        'Action started': 'Acción iniciada',
        'avg. response time': 'tiempo de respuesta medio',
        'Call started': 'Llamada iniciada',
        'in': 'pulg',
        'Operation': 'Funcionamiento',
        'Response time': 'Tiempo de respuesta',
    },
    ServiceRequests: {
        'All': 'Todos',
        'Breakdown Maintenance': 'Mantenimiento de averías',
        'Closed': 'Cerrada',
        'Corrective Maintenance': 'Mantenimiento correctivo',
        'Created': 'Creado',
        'Create new': 'Crear nueva',
        'Customer name': 'Nombre del cliente',
        'Enter detailed description of the maintenance request...': 'Ingrese una descripción detallada de la solicitud de mantenimiento...',
        'expertise, or swift troubleshooting.': 'experiencia o solución rápida de problemas.',
        'Fill request form': 'Rellenar formulario de solicitud',
        'Maintenance type': 'Tipo de mantenimiento',
        'Mark request as complete': 'Marcar solicitud como completada',
        'No customer selected': 'Ningún cliente seleccionado',
        'No service requests': 'Ninguna solicitud de servicio',
        'Other Maintenance': 'Otros mantenimientos',
        'Request received': 'Solicitud recibida',
        'Request urgent repairs, additional maintenance': 'Solicitar reparaciones urgentes, mantenimiento adicional',
        'Phone number': 'Número de teléfono',
        'Preferred maintenance date (Kalmar cannot guarantee maintenance on this date)': 'Fecha de mantenimiento preferida (Kalmar no puede garantizar el mantenimiento en esta fecha)',
        'Preventive Maintenance': 'Mantenimiento preventivo',
        'Search request': 'Buscar solicitud',
        'Equipment location': 'Ubicación del equipo',
        "This can't be changed": 'Esto no se puede cambiar',
        'Thank you for your service request. We will contact you by phone as soon as possible during business hours.': 'Gracias por su solicitud de servicio. Nos pondremos en contacto con usted por teléfono lo antes posible dentro del horario laboral.',
        'Your reference': 'Su referencia'
    },
    SessionExpirationModal: {
        'Log in again': 'Volver a iniciar sesión',
        'You have been logged out due to inactivity': 'Se ha cerrado la sesión por inactividad',
        'Your session has expired': 'Su sesión ha expirado',
    },
    SiteSelector: {
        'Customer': 'Cliente',
        'No sites with equipment': 'Ningún lugar con equipos',
        'Select a customer': 'Seleccionar un cliente',
        'Selected': 'Seleccionado',
        'Show all sites': 'Mostrar todos los sitios',
        'Showing all sites': 'Mostrando todos los lugares',
        'Recently visited': 'Visitado recientemente',
    },
    StockEquipment: {
        'Price': 'Precio',
        'Currency': 'Moneda',
        'Please select a currency for the price': 'Por favor, seleccione una moneda para el precio',
        'Contact email': 'Correo electrónico de contacto',
        'Added': 'Añadido',
        'All': 'Todos',
        'Cancel': 'Cancelar',
        'Close': 'Cerrar',
        'Configuration number': 'Número de configuración',
        'Confirm': 'Confirmar',
        'Create stock equipment': 'Crear equipo en stock',
        'Datasheet': 'Ficha técnica',
        'Datasheets': 'Fichas técnicas',
        'Delete': 'Eliminar',
        'Delete this equipment. This action can’t be undone.': 'Eliminar este equipo. Esta acción no se puede deshacer',
        'Description': 'Descripción',
        'Details': 'Detalles',
        'Documents': 'Documentos',
        'Edit': 'Editar',
        'Engine type': 'Tipo de motor',
        'Equipment added successfully': 'Equipo añadido correctamente',
        'Equipment adding failed': 'Error al añadir el equipo',
        'Estimated availability': 'Disponibilidad estimada',
        'If you are interested in this equipment, please contact your local Kalmar sales representative or email us at': 'Si está interesado en este equipo, comuníquese con su representante de ventas local de Kalmar o envíenos un correo electrónico a',
        'Manufacturing year': 'Año de fabricación',
        'MAU location': 'Ubicación MAU',
        'Mark as active': 'Marcar como activo',
        'Mark as inactive': 'Marcar como inactivo',
        'Mark as reserved': 'Marcar como reservado',
        'Mark as sold': 'Marcar como vendido',
        'Cancel reservation': 'Cancelar reserva',
        'Copy and create new': 'Copiar y crear nuevo',
        'More options': 'Más opciones',
        'ACTIVE': 'Activo',
        'INACTIVE': 'Inactivo',
        'RESERVED': 'Reservado',
        'SOLD': 'Vendido',
        'Mark equipment as sold. This action can’t be undone.': 'Marcar este equipo como vendido. Esta acción no se puede deshacer',
        'Model': 'Modelo',
        'No equipment found': 'No se encontró ningún equipo',
        'Picture': 'Imagen',
        'Pictures': 'Imágenes',
        'Ready': 'Disponible',
        'Region': 'Región',
        'Regions': 'Regiones',
        'Search equipment with name, serial number, description, model or site...': 'Buscar equipo por nombre, número de serie, descripción, modelo o sitio...',
        'Search with name, serial number or description': 'Buscar por nombre, número de serie o descripción',
        'See all stock equipment ready to deliver': 'Ver todo el equipo en stock listo para entregar',
        'Select equipment type': 'Seleccionar tipo de equipo',
        'Select region': 'Seleccionar región',
        'Send': 'Enviar',
        'Show on page': 'Mostrar por página',
        'Something went wrong': 'Algo salió mal',
        'Specification': 'Especificación',
        'Specifications': 'Especificaciones',
        'Stock equipment details': 'Detalles del equipo en stock',
        'Type': 'Tipo',
        'Upload': 'Subir',
        'Picture is too large. Please upload a picture smaller than 8 MB.': 'La imagen es demasiado grande. Por favor, suba una imagen de menos de 8 MB.',
        'Contact': 'Contacto',
        'Stock equipment': 'Equipo en stock',
        'Show more': 'Mostrar más',
        'Show less': 'Mostrar menos',
    },
    TimeUnitLinks: {
        'Show': 'Mostrar',
    },
    Tooltips: {
        'Content': 'Content',
        'Recent reports': 'Recent reports',
    },
    TrainingRequests: {
        'All': 'Todos',
        'Closed': 'Cerrada',
        'Created': 'Creado',
        'Create new': 'Crear nueva',
        'Customer name': 'Nombre del cliente',
        'Customer number': 'Número de cliente',
        'Eco Driving Training': 'Formación en conducción ecológica',
        'Enter detailed description of the training request...': 'Introduzca una descripción detallada de la solicitud de formación...',
        'Number of participants': 'Número de participantes',
        'Operator Training': 'Formación para operadores',
        'Phone number': 'Número de teléfono',
        'Preferred time frame for training (Kalmar can’t guarantee training during this time frame, the training is reserved only after Kalmar has contacted you)': 'Periodo de tiempo preferido para la formación (Kalmar no puede garantizar la formación durante este periodo de tiempo, la formación solo se reservará después de que Kalmar se haya puesto en contacto con usted)',
        'Product Training': 'Formación sobre productos',
        'Reach out to one of our training specialists today.': 'Póngase en contacto con uno de nuestros especialistas en formación hoy mismo.',
        'Receive hands-on training with heavy equipment and jobsite skills from industry professionals.': 'Reciba formación práctica con maquinaria pesada y habilidades en el lugar de trabajo de la mano de profesionales del sector.',
        'Request received': 'Solicitud recibida',
        'Search training': 'Buscar formación',
        'Show requests': 'Mostrar solicitudes',
        'Technical Training': 'Formación técnica',
        'Thank you for your training request. We will contact you by phone as soon as possible during business hours.': 'Gracias por su solicitud de formación. Nos pondremos en contacto con usted por teléfono lo antes posible durante el horario laboral.',
        'Training type': 'Tipo de formación',
    },
};
